module.exports = {
	"pathContext": {
		"path": "/shop/merino-pom-pom-beanie/"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/shop-merino-pom-pom-beanie.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/shop-merino-pom-pom-beanie.json
// module chunks = 110940295940287